import { render, staticRenderFns } from "./updateCompany.vue?vue&type=template&id=7021ecd6&scoped=true"
import script from "./updateCompany.vue?vue&type=script&lang=js"
export * from "./updateCompany.vue?vue&type=script&lang=js"
import style0 from "./updateCompany.vue?vue&type=style&index=0&id=7021ecd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021ecd6",
  null
  
)

export default component.exports